import { useQuery } from '@tanstack/react-query';
import { getAdminActivity } from '../api/adminActivity';

/**
 * Cross-team session activity for the last `days`.
 *
 * Keyed by `days` so switching the window refetches rather than reusing
 * a shorter window's rows. Not team-scoped, so unlike most caches in the
 * app it survives a team switch untouched — but the admin team-swap purge
 * drops every non-profile key anyway, which is harmless here.
 */
export const useAdminActivity = (days: number) =>
  useQuery({
    queryKey: ['admin-activity', days],
    queryFn: () => getAdminActivity(days),
  });
